import React, { useState, useMemo } from 'react';
import './IncidentBanner.css';
import { Row, Col } from 'react-bootstrap';
import { getActiveIncidents } from '../../data/announcements';

const IncidentBanner = () => {
  const active = useMemo(() => getActiveIncidents('incident'), []);

  //const active = getActiveIncidents()

  console.log(active)
  const [dismissedIds, setDismissedIds] = useState(() => new Set());

  const toShow = active.filter((a) => !dismissedIds.has(a.id));
  const item = toShow[0] ?? null;

  const handleDismiss = () => {
    if (item) setDismissedIds((prev) => new Set(prev).add(item.id));
  };

  if (!item) return null;

  return (
    <section className="announcement-section" role="status" aria-live="polite">
      <div className="gn-container">
        <Row className="align-items-center g-3">
          <Col md={1} xs={2} className="text-md-start text-center">
            <div className="announce-icon" aria-hidden="true">★</div>
          </Col>
          <Col md={9} xs={10}>
            <div className="announce-content">
              <span className="announce-eyebrow">{item.eyebrow}</span>
              <h3 className="announce-title">{item.title}</h3>
              <p className="announce-desc">{item.description}</p>
            </div>
          </Col>
          <Col md={2} className="text-md-end text-center">
            <div className="announce-actions">
              {item.ctaLabel && item.ctaHref && (
                <a className="btn btn-gn-secondary me-2" href={item.ctaHref}>
                  {item.ctaLabel}
                </a>
              )}
              <button className="announce-dismiss" onClick={handleDismiss} aria-label="Dismiss announcement">
                Dismiss
              </button>
            </div>
          </Col>
        </Row>
      </div>
    </section>
  );
};

export default IncidentBanner;
